<template>
  <article class="effect-card">
    <div class="effect-content-wrapper">
      <h3 class="title">{{title}}</h3>
      <p class="description">{{description}}</p>
    </div>
    <div class="effect-img-wrapper">
      <img class="effect-img" :src='img' :alt='title'>
    </div>
  </article>
</template>

<script>
export default {
  name: 'effectCard',
  props: {
    img: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.effect-card {
  box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  max-width: 880px;
  width: 100%;
  margin: auto;
  border-radius: 6px;
  padding: 32px;
  background-color: #fefefe;
  display: flex;
}
.effect-img-wrapper {
  width: 60%;
  margin: auto;
  margin-top: 16px;
  padding-left: 16px;
  margin: auto;
}
.effect-img {
  width: 100%;
}
.effect-content-wrapper {
  width: 40%;
  .title {
    margin-top: 16px;
  }
  .description {
    text-align: left;
    margin-top: 16px;
    line-height: 2;
    word-break: break-word;
  }
}
@media screen and (max-width: 680px) {
	.effect-card {
		flex-direction: column-reverse;
    align-items: center;
	}
  .effect-img-wrapper, .effect-content-wrapper{
    width: 100%;
    padding: 0;
  }
  .effect-img-wrapper {
    margin-bottom: 16px;
  }
  .effect-content-wrapper {
    .description {
      line-height: 1.5;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/EffectCard.vue